import api from 'services/api';
import Logger from 'components/common/helpers/devConsoleLog';

export const sendEmail = () => async (
  email: string
) => async (): Promise<void> => {
  try {
    await api.post('/send-grid/send-notification', { email });
  } catch (error) {
    Logger('sendemail error:', error);
  }
};

export const sendNotification = (
  emails: string[],
  html: string
) => async (): Promise<void> => {
  try {
    await api.post('/send-grid/send-notification', { emails, html });
  } catch (error) {
    Logger('sendNotification error:', error);
  }
};
